export default "__VITE_ASSET__CUEMipkF__"